export const unicodeSpacesToNonBreakingSpace = (input: string): string => {
  const NON_BREAKING_SPACE = String.fromCharCode(160)
  const UNICODE_SPACES_REGEX = /[\u00A0\u1680\u180e\u2000-\u2009\u200a\u200b\u202f\u205f\u3000]/g

  return input.replace(UNICODE_SPACES_REGEX, NON_BREAKING_SPACE)
}
